// extracted by mini-css-extract-plugin
export var linkText = "_oh-0";